import { useState } from "react";
import { faqItems } from "@/mocks/comics";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 max-w-3xl mx-auto">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 mt-2">关于韩漫之家，你可能想了解的事情</p>
      </div>
      <div className="flex flex-col gap-3">
        {faqItems.map((item, index) => (
          <div
            key={index}
            className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
              <i
                className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                  openIndex === index ? "rotate-180" : ""
                }`}
              ></i>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? "max-h-64 pb-4" : "max-h-0"
              }`}
            >
              <p className="px-5 text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}